export default () => ({
    liveMonitoring: null,
    selectedProjects: [],
    legendSelection:{green: true, yellow: true, red: true, noHealth: true}
});
